(function (root) {
  'use strict';
  const bundles = typeof module !== 'undefined' && module.exports ? require('./knife-finder-bundles.js') : root.DalstrongKnifeFinderBundles || {};
  const kinds = [
    ['bread', /bread|serrated offset/], ['boning', /boning|skinning/], ['fillet', /fillet|filet/],
    ['paring', /paring|bird.?s.?beak/], ['nakiri', /nakiri|vegetable|produce|chinese cleaver/],
    ['santoku', /santoku/], ['butcher', /butcher|breaking|cimitar|scimitar/],
    ['slicer', /slic(?:er|ing)|carving|sujihiki|yanagiba|tuna/],
    ['chef', /chef|kiritsuke|crixus|barong/], ['cleaver', /cleaver|chopper|obliterator|annihilator/],
    ['utility', /utility|tomato/], ['steak', /steak/], ['specialty', /knife|knives|blade|ulu|menkiri/]
  ];
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const normalize = value => String(value || '').replace(/&quot;|&#34;|[″“”]/g, '"').replace(/&amp;/g, '&').replace(/[’‘]/g, "'").toLowerCase();
  const shape = text => kinds.find(([, pattern]) => pattern.test(text))?.[0] || null;
  const reviewed = {
    'gladiator-series-obliterator-meat-cleaver': { kind: 'cleaver', steel: 'other', care: 'easy', handling: 'heavy', boneCapable: true, styles: ['bold'] },
    'gladiator-series-annihilator': { kind: 'cleaver', steel: 'other', care: 'easy', handling: 'heavy', boneCapable: true, styles: ['bold'] },
    'meat-cleaver-9-obliterator-shadow-black-series-nsf-certified-dalstrong': { kind: 'cleaver', steel: 'other', care: 'easy', handling: 'heavy', boneCapable: true, styles: ['dark', 'bold'] }
  };
  function classify(raw, override) {
    const title = normalize(raw.title), type = normalize(raw.productType), tags = (raw.tags || []).map(normalize);
    const description = normalize(raw.description).replace(/<[^>]*>/g, ' ');
    const components = bundles[raw.handle] || [];
    const identity = title + ' ' + type;
    const componentText = normalize(components.map(c => c.title).join(' '));
    const isSet = raw.isBundle || components.length > 0 || /carving set|knife set|knives set|block set|knife bundle|\btrio\b|\bbundle\b|\bpair\b|\d[ -]piece.*(?:knife|knives)|(?:knife|knives).*\d[ -]piece/.test(identity) || tags.includes('knife set') || tags.includes('bundle');
    const excluded = /peeler|knife (?:roll|bag|storage)|sharpen|honing|cutting board|apron|apparel|gift card|service|tasting spoon|grater|meat fork/.test(type) || /universal knife block|empty knife block|\bapparel\b|\b(?:hat|cap|tee|t-shirt)\b/.test(title) || (!isSet && /(?:meat|carving|grill) fork/.test(title));
    const knife = !excluded && (Boolean(shape(identity)) || isSet || tags.includes('knife') || tags.includes('knives'));
    if (!knife) return null;
    let kind = shape(title) || shape(type) || 'specialty';
    if (/cleaver/.test(title) && !/hybrid|chef|chinese|vegetable/.test(title)) kind = 'cleaver';
    const taggedSteel = tags.join(' ');
    const specifications = normalize(raw.specifications);
    const dedicatedSteel = specifications.match(/(?:blade material|blade steel|steel type|steel)\s*:\s*([^;|]{1,120})/)?.[1];
    const material = dedicatedSteel || (description.match(/blade material\s*:?\s*([^\n]{0,140})/)?.[1] || '') + ' ' + taggedSteel;
    let steel = 'unknown';
    const german = /german|thyssen|x50crmov15/.test(material), japanese = /japanese|aus[- ]?10|aus[- ]?8|vg[- ]?10|v[- ]?12/.test(material);
    if (german !== japanese) steel = german ? 'german' : 'japanese';
    else if (!german && /9cr18|7cr17|swedish|american|14c28n|10cr15|stainless steel/.test(material)) steel = 'other';
    const lengths = [...title.matchAll(/(\d{1,2}(?:\.\d+)?)\s*(?:"|inch(?:es)?\b)/g)].map(m => Number(m[1])).filter(n => n > 0 && n <= 30);
    const length = !isSet && lengths.length ? lengths[0] : null;
    const styles = [];
    if (/shadow black|night shark|midnight|black (?:blade|finish)|onyx/.test(identity + ' ' + taggedSteel)) styles.push('dark');
    if (/wood handle|olive wood|resinwood|valhalla|wood resin/.test(identity + ' ' + taggedSteel)) styles.push('natural');
    if (/shadow black|handlecolor_(?:red|blue|orange|green|camouflage|lilac|peach)|scorpion|firestorm|damascus|obliterator|annihilator|devastator|punisher|bestiarius|rick and morty|beetlejuice|lord of the rings|batman|superman|wonder woman|joker|game of thrones|camouflage|fuchsia|teal|lilac|peach|red handle|blue handle|orange handle/.test(identity + ' ' + taggedSteel)) styles.push('bold');
    if (!styles.length && /polished satin|clean|gladiator|vanquish|phantom|crusader/.test(identity + ' ' + description)) styles.push('classic');
    let care = steel === 'german' ? 'easy' : steel === 'japanese' ? 'fine' : 'unknown';
    if (/easy to sharpen|approachable sharpening/.test(description)) care = 'easy';
    else if (/fine.edge|extra care|hard cutting surfaces|62\+|60.?62/.test(description)) care = 'fine';
    let handling = 'unknown';
    if (!isSet && /featherweight|lightweight (?:blade|knife)|light.weight (?:blade|knife)/.test(description) && kind !== 'cleaver') handling = 'light';
    else if (!isSet && /balanced|optimum balance/.test(description) && kind !== 'cleaver') handling = 'balanced';
    // Generic series descriptions mention knives outside a set; only named contents count.
    const memberNames = { bread: /bread/, boning: /boning|skinning/, fillet: /fillet|filet/, paring: /paring/, nakiri: /nakiri|chinese cleaver/, santoku: /santoku/, butcher: /butcher|breaking|cimitar|scimitar/, slicer: /slic(?:er|ing)|carving|sujihiki|yanagiba/, chef: /chef|kiritsuke|crixus/, cleaver: /cleaver|obliterator|annihilator/, utility: /utility/, steak: /steak/ };
    const sizedContents = [...description.matchAll(/\b\d{1,2}(?:\.\d+)?\s*(?:"|inch(?:es)?)[^.;]{0,35}?(?:knife|cleaver|santoku|nakiri)\b/g)].map(m => m[0]).join(' ');
    const contents = normalize(raw.contents) + ' ' + sizedContents;
    const members = isSet ? Object.entries(memberNames).filter(([, pattern]) => pattern.test(title + ' ' + componentText + ' ' + contents)).map(([key]) => key) : [kind];
    const result = { ...raw, kind, steel, length, care, styles, style: styles[0] || 'unknown', handling, boneCapable: false, isSet, members };
    if (override) for (const key of ['kind', 'steel', 'length', 'care', 'style', 'image']) if (override[key] != null) result[key] = override[key];
    if (override?.style && !result.styles.includes(override.style)) result.styles.unshift(override.style);
    if (own(reviewed, raw.handle)) Object.assign(result, reviewed[raw.handle]);
    result.style = result.styles.includes(result.style) ? result.style : result.styles[0] || 'unknown';
    result.heavy = result.handling === 'heavy';
    return result;
  }
  function decode(page) {
    if (!page || !Array.isArray(page.products) || !Number.isInteger(page.total) || page.total < 0 || !Number.isInteger(page.page) || !Number.isInteger(page.pages) || page.pages < 1 || page.page < 1 || page.page > page.pages) throw new Error('catalog-format');
    return page;
  }
  async function load(config, transport = root.fetch.bind(root)) {
    if (!config.catalogUrl) return config.products;
    const base = new URL(config.catalogUrl, root.location?.origin || config.storeUrl);
    if (config.catalogTheme) base.searchParams.set('preview_theme_id', config.catalogTheme);
    // Keep a stable order even if an older section still supplies stock-based sorting.
    base.searchParams.set('options[unavailable_products]', 'show');
    base.searchParams.set('sort_by', 'price-ascending');
    const get = async (page, attempt) => {
      const url = new URL(base);
      url.searchParams.set('page', page);
      // Bypass cached, mismatched pages when a complete traversal needs recovery.
      if (attempt) url.searchParams.set('_kf_refresh', attempt);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      let data;
      try {
        const response = await transport(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: controller.signal });
        if (!response.ok) throw new Error('catalog-request');
        data = decode(await response.json());
      } finally {
        clearTimeout(timeout);
      }
      if (data.page !== page || data.currency !== config.currency) throw new Error('catalog-context');
      return data;
    };
    const traverse = async attempt => {
      const first = await get(1, attempt), pages = [first];
      if (first.total < 1) throw new Error('catalog-empty');
      if (first.pages > 100) throw new Error('catalog-depth');
      for (let page = 2; page <= first.pages; page += 3) {
        // Settle the batch before retrying so requests from separate attempts never overlap.
        const batch = await Promise.allSettled(Array.from({ length: Math.min(3, first.pages - page + 1) }, (_, n) => get(page + n, attempt)));
        const failure = batch.find(result => result.status === 'rejected');
        if (failure) throw failure.reason;
        pages.push(...batch.map(result => result.value));
      }
      if (pages.some(p => p.total !== first.total || p.pages !== first.pages)) throw new Error('catalog-changed');
      const rows = pages.flatMap(p => p.products), unique = new Set(rows.map(p => String(p.id)));
      if (rows.some(p => p.id == null) || unique.size !== first.total || rows.length !== first.total) throw new Error('catalog-incomplete');
      return rows;
    };
    let rows;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        rows = await traverse(attempt ? Date.now() + '-' + attempt : '');
        break;
      } catch (error) {
        if (attempt === 2 || ['catalog-context', 'catalog-depth', 'catalog-empty'].includes(error.message)) throw error;
        await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1)));
      }
    }
    const overrides = new Map((config.products || []).map(p => [String(p.id), p]));
    return rows.map(p => classify(p, overrides.get(String(p.id)))).filter(Boolean);
  }
  const api = { classify, load };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.DalstrongKnifeFinderCatalog = api;
})(typeof window !== 'undefined' ? window : globalThis);
